<div
  [class.selected]="option.selected"
  [class.disabled]="disabled"
  class="option_wrapper">
  <p class="option_value">{{ option.label }}</p>
</div>
